var j = 0;
jQuery.fn.codaSlider = function(settings) {
	 settings = jQuery.extend({
     easeFunc: "expoinout",
     easeTime: 600,
     toolTip: false
  }, settings);
	return this.each(function(){
		var container = jQuery(this);
		var panelWidth = container.find("div.slide_show_top").width();
		var panelCount = container.find("div.slide_show_top").size();
		var stripViewerWidth = panelWidth*panelCount;
		container.find("div.index_image_box").css("width" , stripViewerWidth);
		var navWidth = panelCount*2;
		if (location.hash && parseInt(location.hash.slice(1)) <= panelCount) {
			var cPanel = parseInt(location.hash.slice(1));
			var cnt = - (panelWidth*(cPanel - 1));
			jQuery("div.index_image_box").css({ left: cnt });
			
		} else { 
			var cPanel = 1;
		};
		
		jQuery("#mycarousel li").removeClass("active");
		jQuery("#mycarousel li").eq(cPanel-1).addClass("active");
			
		container.each(function(i) {
			
			jQuery("a.cross-link").click(function(){
												  
				var cPanel = parseInt(jQuery(this).attr("href").slice(1));
				var cnt = - (panelWidth*(cPanel - 1));
				
				jQuery("#mycarousel li").removeClass("active");
				jQuery(jQuery(this).parent()).addClass("active");
				jQuery("div.index_image_box").animate({ left: cnt}, settings.easeTime, settings.easeFunc);
				
			});	
			
		});
		j++;
		
  });
};
